<!--已废弃-->

<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div :style="{width:width, height:height}" :id="id"></div>
<!--    <div v-if="this.option.length" class="unit">-->
<!--      单位：{{ this.unit }}-->
<!--    </div>-->
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'ChartBar',
  props: {
    id: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    keyName: {
      type: String,
      default: ''
    },
    keyCount: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'VALUE'
    },
    unit: {
      type: String,
      default: '10 thousand CNY'
    },
    dataZoomFlag: {
      type: Boolean,
      default: false
    },
    option: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      dataZoomConfig: [
        {
          type: 'inside',
          start: 0,
          end: 40
        },
        {
          height: 17,
          type: 'slider',
          borderColor: '#fff',
          backgroundColor: '#F4F4F4',
          fillerColor: '#E0E2F5',
          dataBackground: {
            lineStyle: {
              // 线的颜色
              color: '#e0e2f5'
              // width: 3,
              // opacity: 1
            },
            areaStyle: {
              color: '#E0E2F5'
            }
          },
          handleIcon: 'path://M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
          // backgroundColor: 'rgba(52,71,255,0.10)',
          // fillerColor: 'rgba(0,0,0,0)',
          // dataBackground: {
          //   lineStyle: {
          //     // 线的颜色
          //     color: 'rgba(52,71,255,0.50)'
          //   },
          //   areaStyle: {
          //     color: 'rgba(0,0,0,0)'
          //   }
          // }
        }
      ]
    }
  },
  methods: {},
  watch: {
    option: {
      handler (newVal) {
        if (newVal.length) {
          // x轴
          const xData = []
          // 数据
          const data = []
          const bgData = []
          // 背景填充
          let bgCount = 0

          let v = '1'

          // 遍历数据
          newVal.forEach(item => {
            xData.push(item[this.keyName])
            data.push(item[this.keyCount])
            if (bgCount <= item[this.keyCount]) {
              bgCount = Math.ceil(item[this.keyCount])
            }
          })

          for (let i = 0; i < bgCount.toString().length - 1; i++) {
            v += '0'
          }
          v = parseInt(v)

          for (let j = 0; j < newVal.length; j++) {
            bgData.push(Math.ceil(bgCount / v) * v < 100 ? 100 : Math.ceil(bgCount / v) * v)
          }

          const chart = echarts.init(document.getElementById(this.id))
          const option = {
            title: {},
            tooltip: {
              backgroundColor: 'rgba(255,255,255,0)',
              position: 'top',
              formatter: (params) => {
                return `
                  <div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; border-radius: 4px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);">
                          <p style="margin: 0; color: #000; font-size: 14px;">${params.name}</p>
                          <p style="margin: 0; color: #000; font-size: 12px;">
                              ${this.title}:
                              <span style="color: #409EFF">
                                  ${params.value}
                              </span>
                              ${this.unit}
                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div>
                  <div style="margin-top: 5px; position: relative; width: 100%; height: 18px;">
                    <div style="position: absolute; left: 50%; top: 5px; margin-left: -9px; width: 18px; height: 18px; background: #fff; border: 3px solid #FAA800; border-radius: 50%"></div>
                  </div>
                `
              }
            },
            legend: {},
            grid: {
              left: '35px',
              right: '20px',
              top: '30px',
              bottom: this.dataZoomFlag ? '70px' : '30px',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              axisLabel: {
                rotate: 70,
                color: '#000'
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              data: xData
            },
            dataZoom: this.dataZoomFlag ? this.dataZoomConfig : [],
            yAxis: {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: ['#EBEBEB']
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                type: 'bar',
                itemStyle: {
                  barBorderRadius: 2,
                  color: '#f0f0f0'
                },
                barGap: '-100%',
                silent: true,
                z: -1,
                barWidth: 10,
                data: bgData
              },
              {
                // name: 'name1',
                type: 'bar',
                data: data,
                z: 10,
                barWidth: 10,
                itemStyle: {
                  barBorderRadius: 2,
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset: 0, color: '#3447FF'},
                      {offset: 1, color: '#3447FF'}
                    ]
                  )
                },
                emphasis: {
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                        {offset: 0, color: '#3447FF'},
                        {offset: 1, color: '#3447FF'}
                      ]
                    ),
                    opacity: 0.7
                  }
                }
              },
            ]
          }
          chart.setOption(option)
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.unit {
  position: absolute;
  top: 10px;
  right: 35px;
  font-size: 12px;
  color: #717982;
}
</style>
